import { useEffect, useRef } from "react";
import MediaSourcePlayer from "../../../utils/video/MediaSourcePlayer";
import { resolveMediaURL, Media } from "../../../utils/video/video";

const FlickerFreeBackground = () => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const imageRef = useRef<HTMLImageElement | null>(null);

    useEffect(() => {
        const setup = async () => {
            const videoURL = resolveMediaURL("chess-intro-1080p-init.mp4");
            const response = await fetch(videoURL);
            const blob = await response.blob();
            const buffer = await blob.arrayBuffer();
            const contentType = response.headers.get("Content-Type") || "video/mp4";

            const media: Media = {
                data: buffer,
                name: "chess-intro",
                contentType,
                shouldPlayImmediately: true,
                shouldLoop: true,
            };

            if (videoRef.current && imageRef.current) {
                const player = new MediaSourcePlayer(videoRef.current, imageRef.current, () => {});
                player.show(media);
            }
        };

        setup();
    }, []);

    return (
        <div className="background-container">
            <video
                ref={videoRef}
                muted
                disableRemotePlayback
                preload="auto"
                playsInline
                className="background-video"
                poster="/images/chess-intro-landscape-4k.webp"
            />
            <img ref={imageRef} className="background-image" />
        </div>
    );
};

export default FlickerFreeBackground;
